import WhyPodiemCallout from "@/core/infrastructure/repository/why_podiem/WhyPodiemCallout"
import hasData from "@/core/domain/specification/hasData"

export default class WhyPodiemCalloutService {
    whyPodiemCallout: WhyPodiemCallout

    constructor() {
        this.whyPodiemCallout = new WhyPodiemCallout()
    }

    async process() {
        const { data, totalCount } = await this.whyPodiemCallout.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
